var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.classes},[(_vm.preloading)?_c('v-container',{staticClass:"mt-10 pt-10",attrs:{"fluid":""}},[_c('MyLoader')],1):_c('router-view'),_c('BookingFloatingBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }